import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IOptions } from '../../cadastro-agendamento.model';
import { StepFormService } from 'src/app/services/StepForm/step-form.service';
import { Subscription } from 'rxjs';
import { IRequestAcompanhamento } from 'src/app/services/AcompanhanteService/acompanhante.model';

@Component({
  selector: 'app-step-form-2',
  templateUrl: './step-form-2.component.html',
  styleUrl: './step-form-2.component.scss'
})
export class StepForm2Component {
  @Input({ required: true }) FormGroup2!: FormGroup;
  @Input() isView = false;
  vinculosOptions: IOptions[] = [
    { name: 'Ajudante', value: 1 },
    { name: 'Conferente', value: 2 },
    { name: 'Segurança', value: 3 },
    { name: 'Visitante', value: 4 },
    { name: 'Parente', value: 5 }
  ];

  private valueChangesSubscription?: Subscription;

  constructor(
    private fb: FormBuilder,
    private stepFormService: StepFormService
  ) {}

  ngOnInit(): void {
    if (!this.FormGroup2.get('ACPN_LIST')) {
      this.FormGroup2.addControl('ACPN_LIST', this.fb.array([]));
    }

    this.loadStepData();

    this.valueChangesSubscription = this.FormGroup2.valueChanges.subscribe(
      () => {
        this.stepFormService.saveStepData(2, this.FormGroup2.getRawValue());
      }
    );

    this.valueChangesSubscription.add(
      this.FormGroup2.statusChanges.subscribe(() => {
        this.stepFormService.saveStepData(2, this.FormGroup2.getRawValue());
      })
    );

    if (this.isView) {
      this.FormGroup2.disable({ emitEvent: false });
    }
  }

  ngOnDestroy(): void {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }
  normalizeVinculo(index: number): void {
    const group = this.acompanhantesFA.at(index) as FormGroup;
    const ctrl = group.get('NU_VNCL_MTRT');
    if (!ctrl) return;

    const v = ctrl.value;

    if (v === null || typeof v === 'number') return;

    const parsed = v === '' || v == null ? null : Number(v);

    ctrl.setValue(parsed, { emitEvent: false });
  }
  onVinculoChange(value: any, index: number): void {
    const group = this.acompanhantesFA.at(index) as FormGroup;
    const control = group.get('NU_VNCL_MTRT');

    if (!control) return;

    const parsed = value === '' || value == null ? null : Number(value);
    group.patchValue(
      {
        NU_VNCL_MTRT: parsed
      },
      { emitEvent: false, onlySelf: true }
    );

    control.markAsDirty();
    control.markAsTouched();
  }
  escolherOpcao(campo: string, options: any[], value: any): void {
    const selecionado = options.find(opcao => opcao?.value === Number(value));

    this.atualizarCampo(campo, selecionado?.value);
  }
  atualizarCampo(campo: string, valor: any): void {
    if (this.FormGroup2.controls[campo].value !== valor) {
      this.FormGroup2.controls[campo].setValue(valor);
    }
  }

  get acompanhantesFA(): FormArray {
    return this.FormGroup2.get('ACPN_LIST') as FormArray;
  }

  createAcompanhanteGroup(data?: any): FormGroup {
    return this.fb.group({
      NM_ACPN: [data?.NM_ACPN || ''],
      NU_VNCL_MTRT: [data?.NU_VNCL_MTRT],
      DT_NASC: [data?.DT_NASC || ''],
      TX_DOC_VNCL: [null],
      PK_ACPN: [null]
    });
  }

  loadStepData(): void {
    const stepData = this.stepFormService.getStepData(2);

    while (this.acompanhantesFA.length) {
      this.acompanhantesFA.removeAt(0);
    }

    if (stepData?.acompanhantes && stepData.acompanhantes.length > 0) {
      const normalizedAcompanhantes = stepData.acompanhantes.map(
        (bodyReq: IRequestAcompanhamento) => {
          return {
            ...bodyReq
          };
        }
      );

      normalizedAcompanhantes.forEach((acompanhante: any) => {
        this.acompanhantesFA.push(this.createAcompanhanteGroup(acompanhante));
      });
    } else {
      this.addAcompanhante();
    }
  }

  addAcompanhante(): void {
    this.acompanhantesFA.push(this.createAcompanhanteGroup());
    this.FormGroup2.updateValueAndValidity();
  }

  removeAcompanhante(index: number): void {
    if (this.isView) {
      return;
    }
    if (this.acompanhantesFA.length <= 1) {
      const group = this.acompanhantesFA.at(index) as FormGroup;
      group.reset();
      group.markAsUntouched();
    } else {
      this.acompanhantesFA.removeAt(index);
    }

    this.FormGroup2.updateValueAndValidity();
  }

isFormValid(): boolean {
  if (!this.acompanhantesFA || this.acompanhantesFA.length === 0) {
    return true; 
  }

  for (let i = 0; i < this.acompanhantesFA.length; i++) {
    const acompanhanteGroup = this.acompanhantesFA.at(i) as FormGroup;
    const nome = acompanhanteGroup.get('NM_ACPN')?.value;

    if (nome && nome.trim() !== '') {
      const dataNascimento = acompanhanteGroup.get('DT_NASC')?.value;
      if (
        !acompanhanteGroup.get('NM_ACPN')?.valid ||
        !acompanhanteGroup.get('DT_NASC')?.valid ||
        !dataNascimento
      ) {
        return false;
      }
    }
  }

  return true;
}
}
